import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Main from "./layouts/Main";
import NotFound from "./pages/NotFound";

import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";
//import AccountState from "./states/AccountState";
import { AuthProvider } from "./Context/AuthContext";
import { NotificationProviderWrapper } from "./Context/NotificationProviderWrapper";
import Upload from "./apps/Upload";
import Uploadupdate from "./apps/Uploadupdate";
// import css
import "./assets/css/remixicon.css";
// import scss
import "./scss/style.scss";
import ProtectedRoute from "./components/ProtectedRoute";

// set skin on load
window.addEventListener("load", function () {
   let skinMode = localStorage.getItem("skin-mode");
   let HTMLTag = document.querySelector("html");

   if (skinMode) {
      HTMLTag.setAttribute("data-skin", skinMode);
   }
});

export default function App() {
   return (
      <React.Fragment>
         <AuthProvider>
            <NotificationProviderWrapper>
               <Routes>
               <Route
                  path="/"
                  element={<ProtectedRoute element={<Main />} />}>
                  <Route
                     index
                     element={
                        <Navigate
                           to="dashboard/home"
                           replace
                        />
                     }
                  />
                  <Route
                     path="apps/uploadupdate"
                     element={<Uploadupdate />}
                  />
                  <Route
                     path="apps/upload"
                     element={<Upload />}
                  />
                  {protectedRoutes.map((route, index) => (
                     <Route
                        path={route.path}
                        element={route.element}
                        key={index}
                     />
                  ))}
               </Route>
               {publicRoutes.map((route, index) => {
                  return (
                     <Route
                        path={route.path}
                        element={route.element}
                        key={index}
                     />
                  );
               })}
               <Route
                  path="*"
                  element={<NotFound />}
               />
            </Routes>
            </NotificationProviderWrapper>
         </AuthProvider>
      </React.Fragment>
   );
}
